import React from "react";

const ErrorModel = ({
    isOpen,
    title = "Alert!",
    message = "Something went wrong.",
    buttonText = "OK",
    onClose,
    secondaryButtonText = null,
    onSecondaryAction = null
}) => {
    if (!isOpen) return null;

    return (
        <div className="confirm-modal-backdrop">
            <div className="confirm-modal-container">
                <h2 className="confirm-modal-title">{title}</h2>
                {/* <h2 className="confirm-modal-title">{title}</h2> */}
                <p className="confirm-modal-message text-start" style={{ whiteSpace: "pre-line" }}>{message}</p>
                <div className="confirm-modal-buttons d-flex flex-column justify-content-center align-items-center gap-2 text-center">
                    {secondaryButtonText && onSecondaryAction && (
                        <button
                            onClick={onSecondaryAction}
                            className="confirm-modal-btn confirm-btn w-100"
                            style={{ backgroundColor: "#235594" }}
                        >
                            {secondaryButtonText}
                        </button>
                    )}

                    <button
                        onClick={onClose}
                        className="confirm-modal-btn confirm-btn w-100"

                    >
                        {buttonText}
                    </button>

                </div>
            </div>
        </div>
    );
};

export default ErrorModel;
